import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ShimmerLoader from "./ShimmerLoader/ShimmerLoader";

const Error400 = () => {
  const [loader,setLoader]=useState(true)
  const navigate = useNavigate()
  useEffect(() => {
    const sessionToken = localStorage.getItem('sessionToken');


    if(sessionToken){
      navigate('/dashboard')
    }else{
      navigate('/login')
    }
    setLoader(false)

  }, [])

  return (
    <>
      {loader?<ShimmerLoader/>:
    <div className='authincation'>
      <div className='container'>
        {" "}
        <div className='row justify-content-center h-100 align-items-center'>
          <div className='col-md-7'>
            <div className='form-input-content text-center error-page'>
              <h1 className='error-text font-weight-bold'>400</h1>
              <h4>
                <i className='fa fa-thumbs-down text-danger' /> Bad Request
              </h4>
              <p>Your Request resulted in an error</p>
              <div>
                <Link className='btn btn-primary' to='/dashboard'>
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
}
    </>
  );
};

export default Error400;
